import logger from '@goldcast/logger';

export const getErrorMessage = err => {
  const errorMsg = 'Some error occurred!';
  if (err) {
    if (err.errors && err.errors.length) {
      if (err.errors[0].errorType === 'DynamoDB:DynamoDbException') {
        // TODO: check behavior, returning correct object though
        return null;
      }
      return err.errors[0].message || errorMsg;
    }
    return errorMsg;
  }
  return null;
};

const INITIAL_STATE = {};

// Helper function to sanitize user data for localStorage
// Only storing essential non-sensitive data that is actually used in the application
const sanitizeUserData = user => {
  if (!user) return null;
  return {
    id: user.id,
    organization: user.organization,
    role: user.role,
    is_admin: user.is_admin,
    is_content_lab_standalone: user.is_content_lab_standalone,
    workspaces: user.workspaces,
    requester_role: user.requester_role
  };
};

export const loadState = () => {
  try {
    const serializedState = window.localStorage.getItem('gc-state-info');
    if (serializedState === null) {
      return INITIAL_STATE;
    }
    const state = JSON.parse(atob(serializedState));
    return {
      currentUser: sanitizeUserData(state?.currentUser),
      sponsorUser: state?.sponsorUser
    };
  } catch (error) {
    logger.error('Failed to load state from localStorage:', error);
    return INITIAL_STATE;
  }
};

export const saveState = state => {
  try {
    const sanitizedState = {
      currentUser: sanitizeUserData(state?.currentUser),
      sponsorUser: state?.sponsorUser
    };
    const serializedState = JSON.stringify(sanitizedState);
    window.localStorage.removeItem('state'); //temp line to remove old key
    window.localStorage.setItem('gc-state-info', btoa(serializedState));
  } catch (error) {
    logger.error('Failed to save state to localStorage:', error);
  }
};
